import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";

export const FinancialInformation = () => {
    const {t} = useTranslation()
    const [state, setState] = useState<boolean>(false)
    const lang = getCookie('BINEXLANG')
    return(
        <>
        <div className="contentBox">
            <div>
                {lang === 'Kr' ?
                <h3>바이넥스의 <span>재무정보를 안내해 드립니다.</span></h3>
                :
                <h3>Binex provides its <span>financial information</span></h3>


                }

                <div className="tabBtnBox">
                    <div>
                        <div onClick={()=>setState(false)}>
                            <button className={!state ? 'active' : ''}>{t("invest_financial_tab_1")}</button>
                        </div>
                        <div onClick={()=>setState(true)}>
                            <button className={state ? 'active' : ''}>{t("invest_financial_tab_2")}</button>
                        </div>
                    </div>
                </div>

                <div className="tabContentBox">
                    <div className={!state ? 'active' : ''}>
                        <h4>
                            {t("invest_financial_content_1_1")}
                            <span>{t("invest_financial_content_1_2")}</span>
                        </h4>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t("invest_financial_content_1_3")}</th>
                                        <th>{t("invest_financial_content_1_28")} (2025.12)</th>
                                        <th>{t("invest_financial_content_1_4")} (2024.12)</th>
                                        <th>{t("invest_financial_content_1_5")} (2023.12)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>{t("invest_financial_content_1_7")}</th>
                                        <td>111,527</td>
                                        <td>90,323</td>
                                        <td>70,492</td>

                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_8")}</th>
                                        <td>199,491</td>
                                        <td>188,760</td>
                                        <td>185,234</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_9")}</th>
                                        <td>
                                            <span>311,018</span>
                                        </td>
                                        <td>
                                            <span>279,083</span>
                                        </td>
                                        <td>
                                            <span>255,726</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_10")}</th>
                                        <td>62,430</td>
                                        <td>91,994</td>
                                        <td>67,358</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_11")}</th>
                                        <td>61,292</td>
                                        <td>5,538</td>
                                        <td>8,176</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_12")}</th>
                                        <td>
                                            <span>123,722</span>
                                        </td>
                                        <td>
                                            <span>97,532</span>
                                        </td>
                                        <td>
                                            <span>75,534</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_13")}</th>
                                        <td>16,342</td>
                                        <td>16,342</td>
                                        <td>15,881</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_14")}</th>
                                        <td>163,213</td>
                                        <td>163,213</td>
                                        <td>135,816</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_15")}</th>
                                        <td>-2,636</td>
                                        <td>-5,235</td>
                                        <td>-5,235</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_16")}</th>
                                        <td>-7,070</td>
                                        <td>-8,567</td>
                                        <td>-6,490</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_17")}</th>
                                        <td>16,447</td>
                                        <td>14,798</td>
                                        <td>40,220</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_18")}</th>
                                        <td>
                                            <span>187,296</span>
                                        </td>
                                        <td>
                                            <span>181,551</span>
                                        </td>
                                        <td>
                                            <span>180,192</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <!-- 재무상태표 Fin --> */}
                        <h4>
                        {t("invest_financial_content_1_19")}
                            <span>{t("invest_financial_content_1_2")}</span>
                        </h4>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t("invest_financial_content_1_3")}</th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_28")}</span>
                                                <span>2025.01.01 ~ 2025.12.31</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_4")}</span>
                                                <span>2024.01.01 ~ 2024.12.31</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_5")}</span>
                                                <span>2023.01.01 ~ 2023.12.31</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_20")}</th>
                                        <td>168,475</td>
                                        <td>130,046</td>
                                        <td>154,825</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_21")}</th>
                                        <td>-3,519</td>
                                        <td>-29,571</td>
                                        <td>2,055</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_22")}</th>
                                        <td><span>-2.09%</span></td>
                                        <td><span>-22.74%</span></td>
                                        <td><span>1.33%</span></td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_23")}</th>
                                        <td>-6,153</td>
                                        <td>-38,249</td>
                                        <td>-4,224</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_24")}</th>
                                        <td>-3,742</td>
                                        <td>-34,500</td>
                                        <td>-4,537</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_25")}</th>
                                        <td>-2.22%</td>
                                        <td>-26.53%</td>
                                        <td>-2.93%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <!-- 손익계산서 Fin --> */}
                    </div>
                    {/* <!-- 별도재무정보 Fin --> */}

                    <div className={state ? 'active' : ''}>
                        <h4>
                            {t("invest_financial_content_1_26")}
                            <span>{t("invest_financial_content_1_2")}</span>
                        </h4>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t("invest_financial_content_1_3")}</th>
                                        <th>{t("invest_financial_content_1_28")} (2025.12)</th>
                                        <th>{t("invest_financial_content_1_4")} (2024.12)</th>
                                        <th>{t("invest_financial_content_1_5")} (2023.12)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>{t("invest_financial_content_1_7")}</th>
                                        <td>112,879</td>
                                        <td>92,571</td>
                                        <td>73,694</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_8")}</th>
                                        <td>198,544</td>
                                        <td>186,817</td>
                                        <td>183,317</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_9")}</th>
                                        <td>
                                            <span>311,423</span>
                                        </td>
                                        <td>
                                            <span>279,388</span>
                                        </td>
                                        <td>
                                            <span>257,011</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_10")}</th>
                                        <td>62,660</td>
                                        <td>92,219</td>
                                        <td>67,443</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_11")}</th>
                                        <td>61,307</td>
                                        <td>5,562</td>
                                        <td>8,243</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_12")}</th>
                                        <td>
                                            <span>123,967</span>
                                        </td>
                                        <td>
                                            <span>97,781</span>
                                        </td>
                                        <td>
                                            <span>75,685</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_13")}</th>
                                        <td>16,342</td>
                                        <td>16,342</td>
                                        <td>15,881</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_14")}</th>
                                        <td>163,974</td>
                                        <td>163,974</td>
                                        <td>135,601</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_15")}</th>
                                        <td>-3,013</td>
                                        <td>-5,612</td>
                                        <td>-5,235</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_16")}</th>
                                        <td>-12,879</td>
                                        <td>-14,049</td>
                                        <td>-11,640</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_17")}</th>
                                        <td>22,873</td>
                                        <td>20,706</td>
                                        <td>46,700</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_17_1")}</th>
                                        <td>159</td>
                                        <td>246</td>
                                        <td>18</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_18")}</th>
                                        <td>
                                            <span>187,456</span>
                                        </td>
                                        <td>
                                            <span>181,607</span>
                                        </td>
                                        <td>
                                            <span>181,325</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <!-- 연결재무상태표 Fin --> */}
                        <h4>
                            {t("invest_financial_content_1_27")}
                            <span>{t("invest_financial_content_1_2")}</span>
                        </h4>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t("invest_financial_content_1_3")}</th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_28")}</span>
                                                <span>2025.01.01 ~ 2025.12.31</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_4")}</span>
                                                <span>2024.01.01 ~ 2024.12.31</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>{t("invest_financial_content_1_5")}</span>
                                                <span>2023.01.01 ~ 2023.12.31</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_20")}</th>
                                        <td>168,475</td>
                                        <td>130,051</td>
                                        <td>154,825</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_21")}</th>
                                        <td>-4,535</td>
                                        <td>-30,755</td>
                                        <td>1,042</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_22")}</th>
                                        <td>
                                            <span>-2.69%</span>
                                        </td>
                                        <td>
                                            <span>-23.65%</span>
                                        </td>
                                        <td>
                                            <span>0.67%</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_23")}</th>
                                        <td>-5,700</td>
                                        <td>-38,927</td>
                                        <td>4,895</td>
                                    </tr>
                                    <tr className="gray">
                                        <th>{t("invest_financial_content_1_24")}</th>
                                        <td>-3,289</td>
                                        <td>-35,180</td>
                                        <td>4,584</td>
                                    </tr>
                                    <tr>
                                        <th>{t("invest_financial_content_1_25")}</th>
                                        <td>-1.95%</td>
                                        <td>-27.05%</td>
                                        <td>2.96%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <!-- 연결재무정보 Fin --> */}
                </div>
            </div>

        </div>
        </>
    )
}
